import { registerSW } from 'virtual:pwa-register';
import {
  isReloadBlocked,
  queueReloadWhileBlocked,
} from '@/app/flowLock';
import {
  bindUpdateChecks,
  createControllerChangeHandler,
  createReloadOnce,
} from '@/pwa/updateLifecycle';

/**
 * Register the PWA service worker with auto-update:
 * skipWaiting + clientsClaim (from vite-plugin-pwa registerType autoUpdate),
 * poll for a new SW on load and when the page is shown, then reload once
 * when a *replacement* worker activates — not on first install.
 */
export function registerPwaUpdates(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const reloadOnce = createReloadOnce(
    () => {
      window.location.reload();
    },
    isReloadBlocked,
    queueReloadWhileBlocked
  );

  const updateSW = registerSW({
    immediate: true,
    onRegisteredSW(_scriptUrl, registration) {
      if (!registration) {
        return;
      }
      bindUpdateChecks(() => {
        void registration.update();
      });
    },
    onNeedRefresh() {
      void updateSW(true);
    },
  });

  navigator.serviceWorker.addEventListener(
    'controllerchange',
    createControllerChangeHandler(
      Boolean(navigator.serviceWorker.controller),
      reloadOnce
    )
  );
}
